import type { DrawerProps } from 'antd';
import { Drawer } from 'antd';
import React from 'react';

const DRAWER_SIZE = {
  default: 530,
  large: '50%',
} as const;

type FBDrawerProps = Omit<DrawerProps, 'size'> & {
  size?: keyof typeof DRAWER_SIZE;
};

const FBDrawer: React.FC<FBDrawerProps> = ({
  size,
  ...rest
}) => (
  <Drawer {...rest} size={DRAWER_SIZE[size ?? 'default']} />
);

export default FBDrawer;
